"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewUtil = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class PreviewUtil {
    static getTitleFromResponse(res) {
        const choices = res?.data?.choices || [];
        let title = undefined;
        let subTitle = undefined;
        for (const choice of choices) {
            const text = choice.text || choice.message?.content || "";
            const keyValues = text.split("\n").filter((x) => x.trim() !== "");
            const results = keyValues.map((kv) => {
                const [title, content] = kv.split(": ");
                return { title: title.trim(), content: content.trim() };
            });
            const foundTitle = results.find((result) => result.title.toLowerCase().includes("title"));
            if (foundTitle) {
                title = foundTitle.content;
            }
            const foundSubtitle = results.find((result) => result.title.toLowerCase().includes("description"));
            if (foundSubtitle) {
                subTitle = foundSubtitle.content;
            }
            if (title && subTitle) {
                break;
            }
        }
        return { title, subTitle };
    }
    /**
     * 将host 和 domain 组装起来
     * @param host
     * @param domain
     */
    static combineHostAndDomain(host, domain) {
        let hostNew = host.trim();
        let domainNew = domain.trim();
        if (hostNew.endsWith(".")) {
            hostNew = hostNew.substring(0, hostNew.length - 1);
        }
        if (domainNew.startsWith(".")) {
            domainNew = domainNew.substring(1, domainNew.length - 1);
        }
        return hostNew + "." + domainNew;
    }
    /**
     * 判断是否为旧数据
     * @param saasUIData
     */
    static isOldDomainData(saasUIData) {
        const domain = saasUIData.settings?.domain;
        if (domain?.data?.requestDomain === undefined && !(0, is_blank_1.default)(domain.data?.inputValue)) {
            return true;
        }
        return false;
    }
    /**
     *
     * @param saasUIData type is PreviewApp.UISaasValueType, corekit can not import fot, so use any
     */
    static getCustomDomain(saasUIData) {
        const domain = saasUIData.settings?.domain;
        if (domain?.data?.domainCheckStatus !== "connected") {
            return undefined;
        }
        const inputValue = domain?.data?.requestDomain;
        if ((0, is_blank_1.default)(inputValue)) {
            // 如果是旧数据，那么需要从不同的字段获取
            if (this.isOldDomainData(saasUIData)) {
                console.log("old domain data previewUtil: ", domain);
                const oldInputValue = domain?.data?.inputValue;
                const oldHost = domain?.data?.hostInputValue;
                return PreviewUtil.combineHostAndDomain((0, is_blank_1.default)(oldHost) ? "www" : oldHost || "", oldInputValue || "");
            }
            return undefined;
        }
        const host = domain?.data?.requestHost;
        return PreviewUtil.combineHostAndDomain((0, is_blank_1.default)(host) ? "www" : host || "", inputValue || "");
    }
    static showEllipsis(previewTitleBoxRef, titleHideRef) {
        if (previewTitleBoxRef.current && titleHideRef.current) {
            return titleHideRef.current.offsetHeight > previewTitleBoxRef.current.offsetHeight;
        }
        return false;
    }
    static isNewProject(template) {
        return (0, is_blank_1.default)(template?.published_metadata_v2?.[0]?.link) || false;
    }
}
exports.PreviewUtil = PreviewUtil;
